import { render, staticRenderFns } from "./product_market.vue?vue&type=template&id=00b1ecbe&scoped=true"
import script from "./product_market.vue?vue&type=script&lang=js"
export * from "./product_market.vue?vue&type=script&lang=js"
import style0 from "./product_market.vue?vue&type=style&index=0&id=00b1ecbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b1ecbe",
  null
  
)

export default component.exports